import { FC } from 'react';
import logo from '@assets/logo.svg';
import logoBg from '@assets/logo-cut.png';
import { useNavigate } from '@tanstack/react-router';
import { OnboardingStep } from './OnboardingStep';

const ONBOARDING_PROGRESS = [
  {
    title: 'Eligibility confirmation',
    subtitle: 'Please confirm that you meet the\n minimum requirements to continue.',
  },
  {
    title: 'Upload Government ID',
    subtitle: 'Verify your identity by scaning\n and uploading your ID.',
  },
  {
    title: 'Watch a short video',
    subtitle: 'Learn what to expect next and\n how to get started.',
  },
];

interface OnboardingSidePanelProps {
  activeStep: number;
  onStepChange: (s: number) => void;
}

export const OnboardingSidePanel: FC<OnboardingSidePanelProps> = ({ activeStep, onStepChange }) => {
  const navigate = useNavigate();

  const handleStep = () => {
    if (activeStep > 0) {
      onStepChange(activeStep - 1);
    } else {
      navigate({ to: '/signup' });
    }
  };

  return (
    <div className="lg:h-full flex-none flex flex-col justify-between justify-self-center lg:justify-self-start lg:bg-[#F2FBFF] rounded-md lg:p-8 lg:pr-0 overflow-hidden">
      <div className="flex flex-col gap-5 lg:gap-[60px] items-center lg:pr-16">
        <img src={logo} alt="Newlane University" className="w-[200px] lg:w-[237px]" />
        <div className="flex lg:flex-col gap-2 md:gap-4 lg:gap-8">
          {ONBOARDING_PROGRESS.map((step, index) => (
            <OnboardingStep
              key={index}
              index={index}
              step={activeStep}
              totalSteps={ONBOARDING_PROGRESS.length}
              title={step.title}
              subtitle={step.subtitle}
            />
          ))}
        </div>
      </div>

      <div className="hidden lg:block relative flex-1">
        <img src={logoBg} className="hidden lg:block absolute top-1/2 -translate-y-1/2 right-0" />
      </div>
    </div>
  );
};
